import { Product } from "../interface/interface";

export const useCSVExport = (products: Product[]) => {
  const handleExport = () => {
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [
        ["Name", "Image", "Price", "Rating"],
        ...products.map((product) => [
          product.name,
          product.image,
          product.price,
          product.rating,
        ]),
      ]
        .map((row) => row.join(","))
        .join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "products.csv");
    document.body.appendChild(link);
    link.click();
  };

  return { handleExport };
};
